/** @format */
import blog_1 from "../assets/Blog/tolam1.webp";
import blog_2 from "../assets/Blog/FED.webp";
import blog_3 from "../assets/Blog/usa.webp";
import blog_4 from "../assets/Blog/blog_4.webp";
import blog_5 from "../assets/Blog/blog_5.webp";
import blog_6 from "../assets/Blog/blog_6.webp";
import auth from "../assets/Blog/esg.webp";
import auth1 from "../assets/Blog/esg1.webp";
import auth2 from "../assets/Blog/esg2.webp";

// Partner

import kng_logo from "../assets/Partner/kng.webp";
import imgpicnamnghi from "../assets/Partner/namnghi_picture.webp";
import imglogoAB from "../assets/Partner/ab.webp";
import imglogoarico from "../assets/Partner/arico.webp";
import imglogoctgroup from "../assets/Partner/ctgroup.webp";
import imglogodimac from "../assets/Partner/dimac.webp";
import imglogochinmedia from "../assets/Partner/chinmedia.webp";
import imglogogreenpan from "../assets/Partner/greenpan.webp";
import imglogomitsubishi from "../assets/Partner/mitsubishi.webp";
import imglogovilladelsol from "../assets/Partner/villadelsol.webp";
import imgsir from "../assets/Partner/sir.webp";
import imglogonamnghi from "../assets/Partner/namnghi.webp";
import imgwatergo from "../assets/Partner/watergo.webp";
import imgwaterbus from "../assets/Partner/waterbus.webp";
import imglogosunshine from "../assets/Partner/sunshine.webp";
import imglogosbp from "../assets/Partner/sbp.webp";
import imglogohedoco from "../assets/Partner/hedoco.webp";
// import imglogohungthinh from "../assets/Partner/hungthinh.webp";
import imglogohungthinh from "../assets/Partner/hung_thinh_logo.png";
import imgHoshizaki from "../assets/Partner/hoshizaki_logo.png";
import imgXuanThao from "../assets/Partner/xuanthao_logo.png";
import imgPhuCuong from "../assets/Partner/phucuong_logo.png";
import imgFilmore from "../assets/Partner/filmore_logo.png";
import imgMDS from "../assets/Partner/mds_logo.png";
import imgOKX from "../assets/Partner/okx_logo.png";
import imgSVF from "../assets/Partner/svf_logo.png";
import imgLegendaryChocolate from "../assets/Partner/ledendary_chocolate_logo.png";
import imgIValue from "../assets/Partner/ivalue_logo.png";
import imgQUT from "../assets/Partner/qut_logo.png";
import imgUQ from "../assets/Partner/uq_logo.png";
import imgSoko from "../assets/Partner/soko_logo.png";

import imgimg from "../assets/Partner/img_1.webp";
import imgjll from "../assets/Partner/jll.webp";

import imgbanner_ab from "../assets/Partner/ab_bannner.webp";
import imgbanner_arico from "../assets/Partner/arico_bannerl.webp";
import imgbanner_dimac from "../assets/Partner/dimac_banner.webp";
import imgbanner_chin from "../assets/Partner/chinmedia_banner.webp";
import imgbanner_ctgroup from "../assets/Partner/ctgroup_banner.webp";
import imgbanner_greenpan from "../assets/Partner/greenpan_banner.webp";
import imgbanner_hiepphat from "../assets/Partner/hiepphatdelasol_banner.webp";
import imgbanner_mitsubishi from "../assets/Partner/mitsubighi_banner.webp";
import imgbanner_namnghi from "../assets/Partner/ab_bannner.webp";
import imgbanner_watergo from "../assets/Partner/saigonwatergo_banner.webp";
import imgbanner_waterbus from "../assets/Partner/saigonwaterbus_banner.webp";
import imgbanner_sir from "../assets/Partner/sir_tailor_banner.webp";

import imgbanner_songbinh from "../assets/Partner/songbinh_banner.webp";
import imgbanner_sunshine from "../assets/Partner/sunshine_banner.webp";
import imgbanner_kngroup from "../assets/Partner/kng_banner.webp";
import imgbanner_hodeco from "../assets/Partner/hedoco_banner.webp";
import imgbanner_hungthinh from "../assets/Partner/hungthinh_banner.webp";
import imgbanner_img from "../assets/Partner/img_banner.webp";
import imgbanner_jll from "../assets/Partner/jll_banner.webp";

import imgbannerHoshizaki from "../assets/Partner/hoshizaki_banner.jpg";
import imgbannerXuanThao from "../assets/Partner/xuanthao_banner.jpg";
import imgbannerPhuCuong from "../assets/Partner/phucuong_banner.jpg";
import imgbannerFilmore from "../assets/Partner/filmore_banner.jpg";

import imgbannerSVF from "../assets/Partner/svf_banner.webp";
import imgbannerLegendaryChocolate from "../assets/Partner/legendary_chocolatier_banner.jpg";
import imgbannerIValue from "../assets/Partner/ivalue_banner.jpg";
import imgbannerQUT from "../assets/Partner/qut_banner.jpg";
import imgbannerUQ from "../assets/Partner/uq_banner.jpg";

// service
import img_service_2 from "../assets/banner_option_2.webp";

import img_about_1 from "../assets/About/AboutIntegrity.webp";
import img_about_2 from "../assets/About/AboutCreative.webp";
import img_about_3 from "../assets/About/AboutActive.webp";
import img_about_4 from "../assets/About/AboutResponsibility.webp";
import img_about_5 from "../assets/About/AboutExcellent.webp";

// home
import home_caousel_1 from "../assets/homebanner_0.webp";
import home_caousel_2 from "../assets/banner_option_5.webp";
import home_caousel_3 from "../assets/banner_option_6.webp";
// import home_caousel_4 from "../assets/banner_option_7.webp";

import { Handshake, ThumbsUp, HandHeart } from "lucide-react";

import Home_Services_01 from "../assets/Home_Services_01.jpg";
import Home_Services_02 from "../assets/Home_Services_02.jpg";
import Home_Services_03 from "../assets/Home_Services_03.jpg";

import { path } from "../utils/common/constant";

export const FoundationValueData = [
  {
    key: "1",
    label: "VISION",
    Children: (
      <div>
        Adding Value, Efficiency and Effectiveness to Enterprises and Community
      </div>
    ),
  },
  {
    key: "2",
    label: "MISSION",
    Children: (
      <div>
        Together invent the future and advance the Sustainable Business Growth
      </div>
    ),
  },
  {
    key: "3",
    label: "CORE VALUE",
    Children: (
      <div>Integrity • Creative • Active • Responsibility • Excellent</div>
    ),
  },
];

export const CoreValueData = [
  {
    key: "1",
    title: "AboutCoreValue_1",
    img: img_about_1,
    content: "AboutCoreValueContent_1",
  },
  {
    key: "2",
    title: "AboutCoreValue_2",
    img: img_about_2,

    content: "AboutCoreValueContent_2",
  },
  {
    key: "3",
    title: "AboutCoreValue_3",
    img: img_about_3,

    content: "AboutCoreValueContent_3",
  },
  {
    key: "4",
    title: "AboutCoreValue_4",
    img: img_about_4,

    content: "AboutCoreValueContent_4",
  },
  {
    key: "5",
    title: "AboutCoreValue_5",
    img: img_about_5,
    content: "AboutCoreValueContent_5",
  },
];

export const blogData = [
  {
    thumbnail: blog_1,

    title:
      "Tổng Bí thư, Chủ tịch nước Tô Lâm: Cơ hội lịch sử đưa thế giới vào kỷ nguyên mới, kỷ nguyên phát triển mới",
    creator_avatar: auth,
    creator: "Tay Nguyen Van",
    category: "News",
    intro_to_artcle: "",
    content:
      "<p> Phát biểu khai mạc, Tổng Thư ký Liên hợp quốc Antonio Guterres khẳng định thế giới đang ở trong giai đoạn chuyển mình và Hội nghị Thượng đỉnh Tương lai lần này là thời khắc quan trọng để đề ra những biện pháp mang tính đột phá cho các vấn đề đang dần vượt ngoài khả năng giải quyết hiện nay như xung đột, tác động của biến đổi khí hậu, thiên tai, dịch bệnh…</p> <p>Chủ tịch Đại Hội đồng Liên hợp quốc Philemon Yang nhấn mạnh trong thách thức, tiềm ẩn nhiều cơ hội để cải tiến, cải tổ và củng cố mạnh mẽ hơn nữa hợp tác toàn cầu vì lợi ích chung của nhân loại và kêu gọi các quốc gia cùng đoàn kết vì một tương lai thịnh vượng cho tất cả mọi người.</p> <p>Hội nghị Thượng đỉnh Tương lai được đánh giá là cơ hội “duy nhất trong thế hệ này” để cộng đồng quốc tế thống nhất về tầm nhìn và cách thức kiến tạo tương lai tốt đẹp hơn cho các thế hệ mai sau. Tại hội nghị, các đại biểu đều nhấn mạnh sự cần thiết phải thúc đẩy cải tổ mạnh mẽ và toàn diện đối với các thể chế đa phương, tăng cường vai trò và tiếng nói của các nước đang phát triển trong các thể chế tài chính toàn cầu, góp phần huy động đủ và sử dụng hiệu quả hơn các nguồn lực để đẩy nhanh tiến độ thực hiện các Mục tiêu phát triển bền vững </p>",
    subheading:
      "Nhấn mạnh những lựa chọn trong hiện tại sẽ định hình tương lai, Tổng Bí thư, Chủ tịch nước cho rằng, mục tiêu phát triển bền vững của thế giới và lợi ích của con người phải được đặt ở trung tâm, là mục tiêu cao nhất.\r\n\r\nTheo đó, thành tựu khoa học công nghệ phải phục vụ tiến bộ xã hội, hướng tới con người, giải phóng con người, phát triển con người toàn diện, không ngừng nâng cao đời sống, bảo đảm lợi ích, hạnh phúc của nhân loại và cho các thế hệ tương lai, tập trung vào phát triển kinh tế, xây dựng xã hội công bằng, văn minh, nâng cao chất lượng cuộc sống của nhân dân, xóa đói giảm nghèo, đồng thời thúc đẩy hợp tác, không được biến thành công cụ chống phá các nước, đi ngược lại nguyện vọng hòa bình, phát triển, công bằng và chính nghĩa của các dân tộc.\r\n\r\n Để làm được điều đó trong giai đoạn bước ngoặt này, Tổng Bí thư, Chủ tịch nước Tô Lâm kêu gọi tăng cường đoàn kết, hợp tác, tôn trọng lẫn nhau, tuân thủ luật pháp quốc tế và Hiến chương Liên hợp quốc; giải quyết bất đồng, tranh chấp bằng biện pháp hòa bình; tăng cường đầu tư, nghiên cứu trong các lĩnh vực phục vụ nhân loại như y học, giáo dục đào tạo, chuyển đổi số, chuyển đổi xanh và các giải pháp phục vụ quần chúng nhân dân.\r\n\r\nTổng Bí thư, Chủ tịch nước nhấn mạnh các nước, nhất là các nước lớn cần hành động có trách nhiệm, chia sẻ những thành tựu chung trong nghiên cứu khoa học, công nghệ để cùng phát triển; ủng hộ vai trò trung tâm, lãnh đạo của Liên hợp quốc, cùng các tổ chức khu vực, trong đó có ASEAN, thúc đẩy hợp tác, ứng phó với các thách thức toàn cầu và tận dụng cơ hội từ những tiến bộ khoa học, công nghệ.\r\n\r\nTổng Bí Thư, Chủ tịch nước Tô Lâm nhận định nhân loại đang đứng trước cơ hội lịch sử để đưa thế giới bước vào thời đại mới, kỷ nguyên phát triển mới tốt đẹp hơn, vì sự phát triển tiến bộ, công bằng xã hội, vì cuộc sống ấm no, tự do, hạnh phúc của người dân khi tất cả cùng thống nhất nhận thức, cùng hành động, cùng nỗ lực và hợp tác chặt chẽ, hiệu quả, đồng thời khẳng định cam kết Việt Nam sẽ đóng góp tích cực, hiệu quả vào các nỗ lực chung nhằm xây dựng thế giới hòa bình, phát triển bình đẳng vì cuộc sống ấm no, hạnh phúc của nhân loại.\r\n\r\nNhân dịp này, Hội nghị cũng đã nhất trí thông qua Văn kiện vì tương lai, Văn kiện số toàn cầu và Tuyên bố về các thế hệ tương lai. Các văn kiện có nội dung toàn diện, đề ra những hành động, mục tiêu đầy tham vọng trên tất cả các lĩnh vực hợp tác tại Liên hợp quốc. Một số ưu tiên cụ thể trong các văn kiện bao gồm tăng cường đầu tư, huy động nguồn lực để đẩy nhanh tiến độ thực hiện các Mục tiêu phát triển bền vững, thiết lập những khuôn khổ, nguyên tắc mang tính nền tảng để thúc đẩy hợp tác số và đổi mới, sáng tạo, chuyển đổi và củng cố các thể chế Liên hợp quốc và các thể chế tài chính quốc tế, để kiến tạo tương lai tốt đẹp hơn cho các thế hệ hôm nay và mai sau.\r\n\r\nHội nghị Thượng đỉnh Tương lai là sáng kiến do Tổng Thư ký Liên hợp quốc Antonio Guterres đưa ra tại Báo cáo “Chương trình nghị sự Chung của Chúng ta” vào năm 2021, nhằm thúc đẩy thảo luận và hợp tác, xây dựng các giải pháp sáng tạo để giải quyết các thách thức toàn cầu như biến đổi khí hậu, phát triển khoa học-công nghệ, công bằng và tiến bộ xã hội, cũng như tăng cường hiệu quả của quản trị toàn cầu.",
  },
  {
    thumbnail: blog_2,
    creator: "Admin",
    category: "News",
    title: "Fed giữ nguyên lãi suất, giá dầu tăng vọt do bất ổn ở Trung Đông",
    creator_avatar: auth1,

    content:
      " “Nếu bài kiểm tra đó được đáp ứng, chúng tôi có thể đưa ra quyết định cắt giảm lãi suất sớm nhất là vào cuộc họp tháng 9”, ông Powell cho biết.\r\n\r\nCổ phiếu công nghệ vốn hóa lớn đã có sự trở lại mạnh mẽ vào thứ Tư sau đợt bán tháo gần đây. Nvidia tăng 12,8%, thu hồi một số khoản lỗ trong tháng 7 và ghi nhận mức tăng trong một ngày lớn nhất kể từ ngày 22 tháng 2. Mức tăng của Nvidia được hỗ trợ bởi kết quả quý 2 tốt hơn dự kiến ​​từ nhà sản xuất chip AMD, một báo cáo đã khơi dậy sự lạc quan về cổ phiếu chip.\r\n\r\nS&P 500 đóng cửa tăng 1,58% ở mức 5.522,30. Nasdaq Composite tăng 2,64% lên 17.599,40. Chỉ số trung bình công nghiệp Dow Jones tăng 99,46 điểm, tương đương 0,24%, lên 40.842,79.\r\n\r\nTrong phiên giao dịch, Dow tăng 1,1%, S&P 500 tăng 2,1% và Nasdaq tăng 3,2%, nhưng sau đó các chỉ số đã thu hẹp mức tăng của mình. Nhiều cổ phiếu Big Tech khác như Apple, Meta Platforms và Amazon cũng tăng. Ngược lại, cổ phiếu Microsoft giảm hơn 1% do kết quả kinh doanh đáng thất vọng.\r\n\r\nMặc dù có mức tăng mạnh này, Nasdaq vẫn kết thúc một tháng thua lỗ, giảm 0,8%. Trong khi đó, S&P 500 tăng 1,1% vào tháng trước và Dow Jones tăng 4,4% - đánh dấu mức tăng hàng tháng mạnh nhất kể từ tháng 12. Kết quả trái ngược của các chỉ số phản ánh rằng các nhà đầu tư đã bán mạnh cổ phiếu công nghệ vào tháng 7 và chuyển vốn sang các cổ phiếu mang tính chu kỳ hơn.\r\n\r\nGiá dầu thô Brent tương lai tại London tăng 2,09 đô la/thùng, tương đương tăng 2,66%, đóng cửa ở mức 80,72 đô la/thùng. Giá dầu thô WTI tương lai tại New York tăng 3,18 đô la/thùng, tương đương tăng 4,26%, đóng cửa ở mức 77,91 đô la/thùng.\r\n\r\nĐây là mức tăng mạnh nhất của dầu WTI kể từ tháng 10 năm ngoái. Tuy nhiên, trong cả tháng 7, giá dầu thô Brent giảm gần 7% và giá dầu thô WTI giảm gần 4%.\r\n\r\nCó hai lý do chính khiến giá dầu tăng mạnh trong phiên này: một là dữ liệu thống kê về tồn kho dầu thô và lý do còn lại là căng thẳng địa chính trị ở Trung Đông lại nóng lên.\r\n\r\nBáo cáo hàng tuần của Bộ Năng lượng Hoa Kỳ cho thấy tồn kho dầu thô thương mại của nước này đã giảm 3,4 triệu thùng vào tuần trước, cao hơn gấp ba lần dự báo giảm 1,1 triệu thùng mà các nhà phân tích đưa ra trong một cuộc khảo sát của Reuters. Đây là tuần thứ năm liên tiếp tồn kho dầu thô của Hoa Kỳ giảm, chuỗi giảm dài nhất kể từ tháng 1 năm 2021.\r\n\r\n“Xuất khẩu dầu mạnh đã bù đắp cho sự suy giảm trong hoạt động lọc dầu tại Hoa Kỳ. Matt Smith, một nhà phân tích tại công ty dữ liệu Kpler cho biết: “Xuất khẩu dầu mạnh đã dẫn đến tuần thứ năm liên tiếp tồn kho dầu thô giảm”, đồng thời nói thêm rằng dữ liệu này “hỗ trợ nhẹ” cho giá dầu.\r\n\r\n“Rủi ro địa chính trị vẫn là động lực chính cho giá dầu tăng ngày hôm nay”, ông Smith nói.\r\n\r\nCăng thẳng ở Trung Đông gia tăng trở lại sau khi Chính phủ Israel hôm thứ Ba tuyên bố lực lượng của nước này đã tiêu diệt chỉ huy cấp cao nhất của lực lượng Hezbollah trong một cuộc không kích nhằm vvào thủ đô Beirut của Lebanon để trả đũa vụ tấn công tên lửa nhằm vào Israel vào tuần trước.\r\n\r\nNgày thứ Tư, một vụ ám sát đã nhằm vào thủ lĩnh chính trị Ismail Haniyeh của lực lượng Hamas khi ông này đang ở Tehran, Iran, khiến vị thủ lĩnh thiệt mạng.\r\n\r\nTrước khi tăng trở lại trong phiên này, giá dầu Brent và WTI đã giảm 1,4% trong phiên ngày thứ Tư, đóng cửa ở mức thấp nhất trong 7 tuần do khả năng sắp có một thỏa thuận ngừng bắn cho dải Gaza – một diễn biến sẽ giúp giải tỏa căng thẳng ở Trung Đông.\r\n\r\n“Những diễn biến mới ở Trung Đông chỉ có thể giúp giá dầu hồi phục tạm thời. Trừ phi hạ tầng dầu khí bị tấn công, sự tăng giá dầu này khó duy trì”, nhà phân tích độc lập Gaurav Sharma ở London nhận định với hãng tin Reuters.\r\n\r\nGiá dầu vẫn đang chịu ảnh hưởng bất lợi từ sự suy giảm nhu cầu dầu ở Trung Quốc, nước nhập khẩu dầu thô lớn nhất thế giới. Kết quả khảo sát công bố ngày thứ Tư cho thấy hoạt động sản xuất ở nước này trong tháng 7 giảm 3 tháng liên tiếp.  Quyết định giữ nguyên lãi suất của Fed tại cuộc họp này không nằm ngoài dự đoán trước đó của thị trường. Tại cuộc họp báo sau cuộc họp của Fed, Chủ tịch Fed Jerome Powell cho biết nếu dữ liệu tiếp tục cung cấp niềm tin rằng lạm phát đang chậm lại, Fed có thể sẵn sàng hành động.\r\n\r\n“Nếu đáp ứng được bài kiểm tra đó, chúng tôi có thể đưa ra quyết định cắt giảm lãi suất sớm nhất là vào cuộc họp tháng 9”, ông Powell cho biết.\r\n\r\nTrong tuyên bố sau cuộc họp, Ủy ban Thị trường mở Liên bang (FOMC) – bộ phận ra quyết định trong Fed – thể hiện quan điểm lạc quan. FOMC nói rằng trong những tháng gần đây, tiến trình đưa ra Việc phát về mục tiêu 2% của Fed đã có tiến trình.\r\n\r\n“Với tuyên bố ngày hôm nay, Fed đang chuẩn bị cho thị trường về nhiều đợt cắt giảm lãi suất sắp tới. Với việc lạm phát được cải thiện và tỷ lệ thất nghiệp tăng, Fed có thể cắt giảm lãi suất trong khi vẫn giữ lãi suất danh nghĩa cao hơn lạm phát. Thị trường sẽ phản ứng tích cực với sự thay đổi tinh tế này trong tuyên bố của Fed”, nhà kinh tế trưởng của LPL Jeffrey Roach nói với CNBC. “Thị trường chứng khoán Mỹ tăng mạnh trong phiên giao dịch thứ Tư (31/7), sau khi Cục Dự trữ Liên bang (Fed) giữ nguyên lãi suất và nhấn mạnh tiến triển trong quá trình giảm lạm phát…”",
  },
  {
    thumbnail: blog_3,
    creator: "Tay Nguyen Van",
    title:
      "Tin tưởng rằng khả năng phát triển chậm lại, Fed đã cắt giảm lãi suất nửa phần trăm",
    creator_avatar: auth2,
    category: "Market",

    content: `Kể từ khi trở thành chủ tịch Fed vào năm 2018, ông Powell luôn thúc đẩy việc hoạch định chính sách dựa trên sự đồng thuận giữa các thành viên của Ủy ban Thị trường Mở Liên bang (FOMC) - cơ quan hoạch định chính sách của Fed. Tuy nhiên, tại cuộc họp này, lần đầu tiên kể từ năm 2005, một thống đốc Fed đã bỏ phiếu chống lại quyết định của ủy ban, và đó là bà Michelle Bowman, người muốn cắt giảm lãi suất chỉ 0,25 điểm phần trăm. Các nhà phân tích cho biết quyết định cắt giảm 0,5 điểm phần trăm của Fed cho thấy động lực mạnh mẽ của ông Powell để bắt đầu chu kỳ nới lỏng một cách thuyết phục.\r\n\r\n Ông Powell gọi động thái của Fed là "sự điều chỉnh" để phù hợp với sự sụt giảm mạnh của lạm phát kể từ năm ngoái. Ông cho biết nền kinh tế Hoa Kỳ vẫn mạnh nhưng Fed muốn đi trước một bước và ngăn chặn mọi sự suy thoái trên thị trường việc làm. Từ những tuyên bố này của người đứng đầu ngân hàng trung ương quyền lực nhất thế giới, các nhà phân tích thấy rằng ông có một mục tiêu bao quát là không đánh đổi mục tiêu lạm phát 2% để lấy tỷ lệ thất nghiệp cao hơn. \r\n\r\n"Một cuộc hạ cánh mềm đang trong tầm tay. Điều đó sẽ hoàn thành di sản của ông với tư cách là chủ tịch Fed", nhà kinh tế trưởng của KPMG Diane Swonk nói với Reuters. \r\n\r\nTại cuộc họp này, Fed cũng cập nhật dự báo hàng quý về lãi suất, lạm phát, thất nghiệp và tăng trưởng kinh tế. "Biểu đồ chấm" của Fed về dự báo lãi suất cho thấy Fed kỳ vọng lãi suất sẽ giảm thêm nửa điểm phần trăm trong phần còn lại của năm nay, một điểm phần trăm đầy đủ vào năm 2025 và một nửa điểm phần trăm vào năm 2026. Tuy nhiên, Fed cũng cảnh báo rằng không có gì chắc chắn trong việc dự báo lãi suất dài hạn. \r\n\r\nViệc cắt giảm lãi suất của Fed diễn ra chỉ bảy tuần trước cuộc bầu cử tổng thống Hoa Kỳ. Tuy nhiên, phản ứng ban đầu của hai ứng cử viên tổng thống đối với động thái của Fed vẫn khá im ắng. Phó Tổng thống Kamala Harris, một đảng viên Dân chủ, gọi việc Fed cắt giảm lãi suất là "tin tốt" cho người dân Mỹ. "Tôi biết giá cả vẫn còn quá cao đối với nhiều gia đình trung lưu và lao động", Harris cho biết trong một tuyên bố. Cựu Tổng thống Donald Trump, một đảng viên Cộng hòa, người đầu tiên bổ nhiệm Powell vào Fed, cho biết việc cắt giảm nửa điểm lãi suất có thể chỉ ra rằng nền kinh tế đang gặp rắc rối. Trump nói với các phóng viên rằng "Việc cắt giảm lãi suất nhiều như vậy, giả sử họ không chơi trò chính trị, thì nền kinh tế hẳn đang trong tình trạng rất tồi tệ".\r\n\r\nTrong khi đó, ông Powell khẳng định nền kinh tế Mỹ vẫn đang khỏe mạnh, với nhiều chỉ số về thị trường việc làm như số đơn xin trợ cấp thất nghiệp lần đầu và thậm chí tỷ lệ thất nghiệp hiện tại 4,2% đều không phải là những con số đáng lo ngại. Tuy nhiên, ông đồng tình với những vấn đề mà giới chuyên gia đặt ra: chính sách tiền tệ có độ trễ để phát huy tác dụng, và với thông tin thu lượm được từ doanh nghiệp cũng như tốc độ tuyển dụng chậm lại, giới chức Fed cảm thấy cần thiết phải chặn trước sự suy yếu mạnh mẽ hơn của thị trường việc làm. Việc này cũng tương tự như quan điểm trước kia rằng Fed cần ra đòn “phủ đầu” đối với lạm phát.\r\n\r\n“Có quan điểm cho rằng giờ là lúc phải hỗ trợ thị trường việc làm, ngay khi thị trường còn mạnh chứ không phải khi sa thải đã bắt đầu xảy ra”, ông Powell nói.\r\n\r\nDự báo cập nhật của Fed cho rằng tốc độ tăng của chỉ số giá tiêu dùng cá nhân (PCE) – thước đo lạm phát được Fed ưa chuộng – sẽ giảm về mức 2,3% vào cuối năm nay và kết thúc năm 2025 ở mức 2,1%.\r\n\r\nVề tỷ lệ thất nghiệp, Fed dự báo con số 4,4% vào cuối năm nay và cho rằng mức này sẽ duy trì cho tới hết năm 2025. Về tăng trưởng kinh tế, Fed dự báo mức tăng 2,1% trong năm nay và 2% vào năm tới, không thay đổi so với dự báo đưa ra hồi tháng 6. Các nhà phân tích cho rằng Chủ tịch Fed Jerome Powell có mục tiêu bao quát là không đánh đổi mục tiêu lạm phát 2% để lấy tỷ lệ thất nghiệp cao hơn…\r\n\r\nCục Dự trữ Liên bang Hoa Kỳ (Fed) vào ngày 18 tháng 9 đã chính thức bắt đầu chu kỳ nới lỏng chính sách tiền tệ được mong đợi từ lâu với mức cắt giảm lãi suất 0,5 điểm phần trăm. Giải thích về mức cắt giảm lớn khi bắt đầu xoay trục, Chủ tịch Fed Jerome Powell cho biết lựa chọn này phản ánh cam kết của các nhà hoạch định chính sách tiền tệ trong việc duy trì tỷ lệ thất nghiệp thấp trong bối cảnh lạm phát đã hạ nhiệt đáng kể.`,
  },
  {
    thumbnail: blog_4,
    creator: "Tay Nguyen Van",
    creator_avatar: auth2,
    category: "News",

    title: "Kỳ vọng cho bức tranh tín dụng",
    content: `Luật Kinh doanh Bất động sản số 29/2023/QH15 và Luật Đất đai số 31/2024/QH15 sẽ có hiệu lực từ ngày 01/08/2024 nếu được Quốc hội thông qua. Cùng với đó, Luật Các tổ chức tín dụng sửa đổi cũng sẽ có hiệu lực từ ngày 01/07/2024.\r\n\r\nGiới phân tích đánh giá, những quy định mới trong các luật này sẽ tác động tích cực đến bức tranh tín dụng bất động sản, đặc biệt là chất lượng tín dụng. Theo ông Phạm Như Ánh, Tổng giám đốc Ngân hàng Thương mại cổ phần Quân đội (MB), tín dụng bất động sản gồm các mảnh ghép gồm (i) ngân hàng cho người dân vay để mua nhà ở, (ii) cho vay phát triển dự án bất động sản khu công nghiệp, (iii) các dự án nhà ở và (iv) bất động sản nghỉ dưỡng. Trong 6 tháng đầu năm, 4 lĩnh vực kể trên đều gặp khó khăn.\r\nTổng giám đốc MB đánh giá trong nửa đầu năm 2024, cho vay mua nhà chưa ghi nhận nhiều tín hiệu khả quan do giá nhà vẫn ở mức cao, cộng thêm kinh tế khó khăn, thu nhập của người dân giảm sút nên giao dịch tương đối ảm đạm.\r\n\r\nTheo cập nhật của VnEconomy từ báo cáo tài chính các ngân hàng niêm yết, cho vay mua nhà vốn là động lực tăng trưởng chính của tín dụng bán lẻ trong nhiều năm với tốc độ tăng trưởng cao CAGR 5 năm đạt 26%, tuy nhiên đà tăng trưởng chững lại từ năm 2023 (với mức tăng trưởng chỉ 1,1% yoy).\r\n\r\nTại hội nghị tín dụng do Ngân hàng Nhà nước tổ chức tuần trước, đại diện một số ngân hàng cho rằng, trở lực lớn đối với tín dụng bất động sản chính là pháp lý. Bởi vậy, vừa qua, Chính phủ cũng như các bộ, ngành đã tập trung tháo gỡ pháp lý cho các dự án bất động sản nhưng mới chỉ được một phần. Quá trình này phụ thuộc vào các luật mới như luật đất đai, luật nhà ở có hiệu lực từ ngày 1/08 tới đây.\r\n\r\nDo đó, một số lãnh đạo ngân hàng nhận định, sau khi các Luật Đất đai, Luật Kinh doanh bất động sản có hiệu lực từ 1/8 thì hàng loạt vấn đề sẽ được tháo gỡ. Hy vọng đến quý 3, quý 4 năm nay, các dự án bất động sản sẽ thông suốt về pháp lý, tạo hiệu ứng tích cực cho thị trường bất động sản. Khi đó, người dân sẽ bắt đầu mua nhà, đổi nhà và tín dụng của các ngân hàng sẽ tăng trưởng tốt hơn.\r\n\r\nHầu hết các bất động sản đều được phép bán theo hình thức “trên giấy”. Các sản phẩm bất động sản mới thúc đẩy cơ hội huy động vốn ngân hàng của các doanh nghiệp. Tuy nhiên, quy định này không áp dụng cho các giao dịch chỉ liên quan đến quyền sử dụng đất đi kèm với hạ tầng kỹ thuật.\r\n\r\nPwC Việt Nam cho biết Luật Các tổ chức tín dụng sửa đổi tạo cơ hội cho tổ chức tín dụng chuyển nhượng các dự án bất động sản là tài sản đảm bảo đáp ứng các quy định nghiêm ngặt để xử lý nợ xấu.\r\n\r\nTừ đó, tạo điều kiện thuận lợi hơn cho việc thu hồi nợ và giảm thiểu nợ xấu trong lĩnh vực bất động sản. Trước đó, luật chỉ cho phép chuyển nhượng các bất động sản đã hoàn thiện để thu hồi nợ, bao gồm: kế hoạch chi tiết đã được phê duyệt, giải phóng mặt bằng đã hoàn thành và có quyết định giao đất, cho thuê đất của cơ quan có thẩm quyền và đã hoàn thành nghĩa vụ tài chính theo quy định của pháp luật về kinh doanh bất động sản.Luật Đất đai mới cho phép các tổ chức trong nước thế chấp quyền sử dụng đất tại các tổ chức khác ngoài tổ chức tín dụng được cấp phép.\r\n\r\nTuy nhiên, doanh nghiệp có vốn đầu tư nước ngoài vẫn bị hạn chế chỉ được thế chấp quyền sử dụng đất tại các tổ chức tín dụng được cấp phép của Việt Nam. Theo các chuyên gia, sự điều chỉnh này tạo ra cơ hội cho nhiều loại hình tổ chức, ví dụ như các tập đoàn đa ngành và các công ty bất động sản tham gia vào các hoạt động tài trợ vốn mà trước đây chỉ dành cho các tổ chức tín dụng. Từ đó, góp phần giảm lệ sự lệ thuộc tín dụng ngân hàng của các doanh nghiệp bất động sản.\r\n\r\nQuy định của Luật Các tổ chức tín dụng sửa đổi sẽ giảm dần hạn mức tín dụng cho từng khách hàng và nhóm khách hàng theo từng năm cho đến năm 2029, từ 15% xuống 10% đối với khách hàng cá nhân và từ 25% xuống 15% đối với nhóm khách hàng có liên quan. PwC Việt Nam đánh giá sự thay đổi này sẽ làm gia tăng tính phức tạp và chi phí vay vốn cho khách hàng bất động sản. Để đáp ứng nhu cầu vốn, họ có thể cần tìm đến các khoản vay hợp vốn, đặc biệt khi cần nguồn vốn lớn\r\n\r\nTổng giám đốc MB cho biết đến nay ngân hàng đã tích cực phát triển các sản phẩm tín dụng, quy trình cấp tín dụng để đáp ứng luật mới và chính sách mới có hiệu lực từ 1/8.\r\n\r\nNgân hàng này cũng dựa vào nền tảng App MBBank cho khách hàng cá nhân và BIZ MBBank cho khách hàng doanh nghiệp để tiếp tục cho vay và phê duyệt tự động. Từ đó rút ngắn quy trình và giảm sự can thiệp của con người trong quá trình ra quyết định tín dụng.\r\n\r\nCũng theo ông Ánh, với những điều kiện thuận lợi từ môi trường pháp lý và sự chủ động từ ngân hàng, MB sẽ đạt mục tiêu tăng trưởng tín dụng 15,5% vào đầu hoặc giữa quý 4/2024. Theo các nhà phân tích, với Luật Kinh doanh Bất động sản sửa đổi, hầu hết bất động sản được phép bán theo hình thức, qua đó thúc đẩy cơ hội huy động vốn ngân hàng của các nhà đầu tư, dẫn đến tăng trưởng tín dụng tích cực trong những tháng cuối năm 2024`,
  },
  {
    thumbnail: blog_5,
    creator: "Tay Nguyen Van",

    title: "Thu hút và giữ chân nhân tài",
    category: "News",
    creator_avatar: auth,

    content: ` GẮN ĐÀO TẠO VỚI NHU CẦU SỬ DỤNG LAO ĐỘNG\r\n\r\nHiện Ban Quản lý các Khu chế xuất – Công nghiệp thành phố đang phối hợp cùng doanh nghiệp đào tạo nhiều lĩnh vực như: Công nghệ thông tin; trí tuệ nhân tạo (AI); internet vạn vật (IoT); dữ liệu lớn (Big Data); giải pháp phần mềm công nghệ thông tin; quản trị mạng; an ninh mạng; điện toán đám mây; thiết kế đồ họa; công nghệ web; lĩnh vực cơ khí – ô tô; tự động hóa; điện tử công nghiệp; t_logistics…\r\n\r\nCùng với công tác đào tạo lại, đào tạo nâng cao cho người lao động trong các khu công nghiệp – chế xuất, đơn vị cũng đồng thời triển khai đào tạo song hành giữa cơ sở giáo dục nghề nghiệp và doanh nghiệp.\r\n\r\nBên cạnh đó, thí điểm tổ chức liên kết đào tạo giữa nhà trường và doanh nghiệp ở các nội dung: Chương trình, giáo trình đào tạo, thời gian thực hành tại doanh nghiệp, vật tư tiêu hao, với tiêu chí đào tạo 50% thời lượng lý thuyết và thực hành cơ bản tại cơ sở giáo dục nghề nghiệp; 50% thời lượng thực hành chuyên sâu tại các doanh nghiệp. Khuyến khích các cơ sở giáo dục nghề nghiệp tư thục vận hành mô hình này trong việc đào tạo tại đơn vị.\r\n\r\nÔng Phạm Anh Thắng, Phó Chánh Văn phòng Bộ Lao động – Thương binh và Xã hội nói cả nước hiện có 52,4 triệu lao động, đây chính là một lợi thế. Tuy nhiên, ông cũng nhìn nhận thực tế tỷ lệ người lao động qua đào tạo hiện nay rất cao, nhưng số qua đào tạo có bằng cấp, chứng chỉ vẫn còn thấp.\r\n\r\nTheo ông, nguyên nhân một phần do doanh nghiệp tự đào tạo cho người lao động sau khi tuyển dụng, song họ không có chức năng cấp bằng cấp, chứng chỉ cho người lao động đó. Bên cạnh đó, một số nghề đang thu hút lao động nhưng chưa được định danh như chạy xe công nghệ, giao hàng…\r\n\r\nTheo ông Thắng, hiện cả nước có hơn 1.800 cơ sở đào tạo nghề, hoàn toàn đủ điều kiện đào tạo cho doanh nghiệp. Tuy nhiên, doanh nghiệp cần liên kết với các cơ sở này để đào tạo được lực lượng lao động có tay nghề.\r\n\r\nTheo ông Trương Anh Dũng, Tổng cục trưởng Tổng cục Giáo dục nghề nghiệp (Bộ Lao động – Thương binh và Xã hội), hiện đơn vị cũng đang tham mưu cho Bộ trình Chính phủ trong xây dựng Luật Việc làm (sửa đổi) với nhiều chính sách phát triển giáo dục nghề nghiệp. Trong đó, có chính sách khuyến khích và tôn vinh để doanh nghiệp tham gia sâu hơn vào công tác đào tạo.\r\n\r\nVấn đề đào tạo cũng là nội dung được Bộ trưởng Bộ Lao động – Thương binh và Xã hội nhấn mạnh trong cuộc làm việc với Cục Việc làm mới đây.\r\n\r\nTheo Bộ trưởng Đào Ngọc Dung, cần tăng cường vai trò quản lý Nhà nước về lao động, việc làm, gắn chặt giữa lao động việc làm với đào tạo. Đặc biệt, đào tạo phải gắn với cung cầu, với thị trường, gắn với sử dụng lao động. Đây chính là khâu đột phá của đào tạo, mục đích để giảm nhanh thị trường lao động phi chính thức, tạo việc làm thỏa đáng và bền vững.  ĐÀO TẠO ĐỂ TẠO RA GIÁ TRỊ LÂU DÀI CHO NGƯỜI LAO ĐỘNG\r\n\r\nChia sẻ về tình hình hiện tại và những khó khăn gặp phải trong việc tuyển dụng nhân sự và kinh nghiệm thực tế để giữ chân người lao động, bà Lâm Thị Ngọc Ngân, Giám đốc Nhân sự Công ty Cổ phần Pizza 4PS, cho biết đặc thù tại đơn vị thuộc ngành dịch vụ nên khi tuyển dụng chủ yếu là lao động trẻ, chưa qua đào tạo.\r\n\r\nTheo bà Ngân, vì lao động trẻ nên để tuyển dụng, công ty phải tiếp cận nhiều kênh, từ truyền thống như báo giấy đến các trang tuyển dụng trực tuyến, thông qua mạng xã hội như Facebook, TikTok, thậm chí từ nguồn giới thiệu của chính nhân viên trong công ty.\r\n\r\nYêu cầu tuyển dụng của doanh nghiệp cao, trong khi cung không đủ cầu, bình quân mỗi năm công ty cần tuyển thành công trên 3.000 nhân sự làm việc toàn thời gian. Như vậy, mỗi tháng cần tuyển 300 nhân sự, để có được số lao động đó thì lượng hồ sơ nhận được rất lớn.\r\n\r\n“Khi tuyển dụng, công ty sẽ đào tạo ngay từ đầu, nhiều vị trí phải bỏ rất nhiều công sức đào tạo song tỷ lệ nhảy việc rất cao, đây là một khó khăn. Do vậy, ngoài tiền lương, điều doanh nghiệp hướng tới là tạo ra nhiều giá trị dài lâu hơn cho người lao động”, Giám đốc Nhân sự Pizza 4PS cho hay.\r\n\r\nHiện nay, phần lớn doanh nghiệp đều quan tâm tổ chức đào tạo, huấn luyện người lao động khi vào làm việc để đáp ứng yêu cầu hoạt động sản xuất – kinh doanh của đơn vị cũng là đánh giá của ông Đàm Trung Hiếu, Phó Trưởng Phòng Quản lý Lao động, Ban Quản lý các Khu chế xuất – Công nghiệp TP. HCM.\r\n\r\nÔng Hiếu thông tin, các doanh nghiệp trong Khu chế xuất – Công nghiệp TP. HCM hoạt động đa dạng về ngành nghề, quy mô và trình độ công nghệ.\r\n\r\nHiện có hơn 250.000 người lao động đang làm việc. Tỷ lệ lao động làm việc tại các doanh nghiệp thuộc 4 ngành trọng yếu có xu hướng tăng (cơ khí; điện tử – công nghệ thông tin; hóa chất – nhựa cao su; chế biến tinh lương thực – thực phẩm). Trên 87% người lao động làm việc đã qua đào tạo.\r\n\r\nTheo ông Hiếu, nhiều doanh nghiệp đã chú trọng đào tạo, bồi dưỡng để bố trí, sử dụng vào các vị trí chức danh công việc quản lý như tổ trưởng, chuyền trưởng, quản đốc, trưởng phòng ban, giám đốc… được chủ doanh nghiệp đưa sang công ty mẹ ở nước ngoài để đào tạo ngắn hạn, dài hạn nhằm nâng cao trình độ, từng bước thay thế chuyên gia nước ngoài.\r\n\r\nCùng với đó, các đơn vị cũng tổ chức đào tạo cho người lao động trước khi vào làm việc, trang bị kiến thức về pháp luật lao động và văn hoá ứng xử trong lao động. Qua đó, góp phần giúp người lao động nắm vững pháp luật lao động, có tác phong làm việc trong môi trường công nghiệp và hành xử theo các quy định của luật pháp Việt Nam. Khó khăn trong việc tuyển dụng và giữ chân người lao động, nhiều doanh nghiệp ngày càng chú trọng vào đào tạo để tạo ra nguồn nhân lực chất lượng cho riêng mình...\r\nTrong bối cảnh thị trường tuyển dụng cạnh tranh, một trong những mối quan tâm lớn của doanh nghiệp là làm thế nào để thu hút và giữ chân nhân tài. Để làm được điều này, doanh nghiệp đã đẩy mạnh công tác đào tạo, coi đây là một lợi thế.`,
  },
  {
    thumbnail: blog_6,
    creator: "Tay Nguyen Van",
    title: "Giá vàng lập đỉnh mới bất chấp đồng USD tăng giá",
    category: "News",
    creator_avatar: auth1,

    content:
      "Tốc độ tăng giá của vàng đang chậm lại ở vùng giá kỷ lục do nhà đầu tư thận trọng hơn. Tuy nhiên, nhiều nhà phân tích tiếp tục lạc quan về triển vọng giá vàng trong dài hạn. Trong một báo cáo mới công bố, ngân hàng Thụy Sỹ UBS dự báo xu hướng tăng giá của vàng có thể kéo dài và đặt mục tiêu giá vàng đạt 2.700 USD/oz trong thời gian từ nay đến giữa năm 2025.\r\n\r\nTheo báo cáo này, giá vàng không chỉ được hỗ trợ bởi kỳ vọng lãi suất giảm, mà còn bởi bất ổn địa chính trị và xu hướng đa dạng hóa dự trữ ngoại hối khỏi đồng USD của các ngân hàng trung ương.\r\n\r\n“Chúng tôi dự báo vàng sẽ tiếp tục là tài sản được ưa chuộng để chống lại rủi ro địa chính trị và lãi suất giảm”, báo cáo viết, và cho rằng nhu cầu vàng của các quỹ ETF sẽ tăng lên trong những tháng sắp tới. “Theo WGC, lượng vàng vật chất mà các quỹ ETF nắm giữ đã tăng tháng thứ tư liên tiếp trong tháng 8 vừa qua. Tổng lượng nắm giữ đã đạt gần 3.182 tấn, cao nhất kể từ đầu năm. So với cuối năm ngoái, số lượng vàng trong các quỹ ETF hiện chỉ còn thấp hơn 44 tấn”, báo cáo nhấn mạnh.\r\n\r\nCác nhà phân tích của UBS khuyến nghị một danh mục đầu tư với các tài sản định giá bằng USD chiếm ưu thế nên phân bổ 5% vốn vào vàng.  Lúc đóng cửa tại thị trường New York, giá vàng giao ngay tăng 6,1 USD/oz so với mức đóng cửa của tuần trước, tương đương tăng 0,23%, chốt ở mức 2.628,5 USD/oz – theo dữ liệu từ sàn giao dịch Kitco. Trong phiên, có thời điểm giá vàng đạt mức cao nhất mọi thời đại 2.634,2 USD/oz.\r\n\r\nTại thời điểm hơn 7h sáng nay theo giờ Việt Nam, giá vàng giao ngay tại thị trường châu Á giảm 2,7 USD/oz so với giá chốt phiên Mỹ, tương đương giảm 0,1%, giao dịch ở mức 2.625,8 USD/oz.\r\n\r\nQuy đổi theo tỷ giá USD bán ra tại ngân hàng Vietcombank, mức giá này của vàng thế giới tương đương gần 78,5 triệu đồng/lượng, tăng 300.000 đồng/lượng so với sáng hôm qua.\r\n\r\n“Thị trường vẫn đang phản ứng với việc Fed giảm lãi suất 0,5 điểm phần trăm vào hôm thứ Tư tuần trước. Fed đã phát tín hiệu rằng họ không còn lo nhiều về lạm phát sẽ làm tốt nhất để đảm bảo rằng thất nghiệp sẽ không trở thành một vấn đề của nền kinh tế Mỹ”, chiến lược gia trưởng Bart Melek của công ty TD Securities nhận định với hãng tin Reuters.\r\n\r\nTheo dữ liệu từ công cụ FedWatch Tool của sàn giao dịch CME, thị trường đang đặt cược khả năng 100% Fed hạ lãi suất trong cuộc họp vào tháng 11. Trong đó, khả năng hạ lãi suất 0,5 điểm phần trăm là 53%, và khả năng hạ lãi suất 0,25 điểm phần trăm là 47%.\r\n\r\nTuy nhiên, phát biểu ngày thứ Hai, Chủ tịch Fed chi nhánh Atlanta – ông Raphael Bostic – nói rằng Fed không vội đưa lãi suất về mức trung tính vì các nhà nhà hoạch định chính sách tiền tệ còn đang thảo luận sâu về việc lãi suất cần giảm bao nhiêu và với tiến độ như thế nào.\r\n\r\nÔng Melek cho rằng nếu tỷ lệ thất nghiệp ở Mỹ tăng mạnh, thị trường sẽ tin rằng Fed sẽ giảm lãi suất quyết liệt, và điều đó sẽ có lợi cho giá vàng.\r\n\r\nCăng thẳng địa chính trị nóng lên ở Trung Đông cũng là một nhân tố quan trọng hỗ trợ giá vàng trong những phiên gần đây.\r\n\r\nNgày thứ Hai, Israel đã tiến hành các cuộc không kích nhằm vào các mục tiêu phiến quân Hezbollah. Gần 1 năm sau ngày cuộc chiến giữa Israel và lực lượng Hamas của Palestine bùng nổ ở Gaza, Israel đang tập trung nỗ lực vào khu vực biên giới phía Bắc, nơi Hezbollah liên tục có các đợt bắn rocket vào lãnh thổ Israel nhằm ủng hộ Hamas.\r\n\r\nTheo dữ liệu từ Hội đồng Vàng Thế giới (WGC), trong tuần trước, các quỹ giao dịch hoán đổi (ETF) vàng đã mua ròng 3 tấn vàng, một lượng mua ròng khá khiêm tốn. Giá vàng cao kỷ lục có thể là một trở ngại đối với nhu cầu của nhà đầu tư.\r\n\r\nPhiên tăng giá ngày đầu tuần của giá vàng diễn ra ngay cả khi lợi suất trái phiếu kho bạc Mỹ và tỷ giá đồng USD tăng.\r\n\r\nLợi suất trái phiếu kho bạc Mỹ kỳ hạn 10 năm tăng gần 2 điểm cơ bản, lên mức 3,749%. Lợi suất của kỳ hạn 2 năm tăng 1,3 điểm cơ bản, lên 3,587%.\r\n\r\nLợi suất tăng khi giới đầu tư trái phiếu tiếp tục nghiền ngẫm về động thái giảm lãi suất mạnh tay của Fed, phân vân rằng liệu đây là một dấu hiệu đáng lo ngại về sức khỏe kinh tế Mỹ hay sẽ giúp nền kinh tế hạ cánh mềm.\r\n\r\nChỉ số Dollar Index đo sức mạnh của bạc xanh so với 6 đồng tiền chủ chốt khác tăng 0,05%, chốt phiên ở mức 100,85 điểm. Trong phiên, có lúc chỉ số này tăng tới 101,23 điểm.\r\n\r\nUSD tăng giá chủ yếu do đồng euro đương đầu áp lực giảm sau số liệu ảm đạm về nền kinh tế khu vực eurozone.\r\n\r\nBáo cáo chỉ số nhà quản trị mua hàng (PMI) tổng hợp của S&P Global cho thấy hoạt động kinh tế ở khối sử dụng đồng tiền chung giảm mạnh và bất ngờ trong tháng 9, với ngành dịch vụ gần như đi ngang, trong khi lĩnh vực sản xuất suy giảm mạnh hơn. Trong khi đó, hoạt động kinh tế Mỹ vẫn duy trì tăng trưởng ổn định, dù ngành sản xuất tiếp tục trạng thái suy giảm. Giá vàng thế giới tăng nhẹ, thiết lập kỷ lục mới trong phiên giao dịch ngày thứ Hai (23/9), nhờ động lực từ việc Cục Dự trữ Liên bang Mỹ (Fed) giảm lãi suất trong tuần vừa rồi. Đà tăng của giá kim loại quý được duy trì dù cả lợi suất trái phiếu kho bạc Mỹ và tỷ giá đồng USD đều tăng.",
  },
];

export const dataService = [
  {
    title: "Home_Service_1",
    content_title: "Home_ServiceDetail_1_ContentTitle",
    content_subtitle: "Home_ServiceDetail_1_ContentSubtitle",
    content_0: "Home_ServiceDetail_1_Content_0",
    content_1: "Home_ServiceDetail_1_Content_1",
    content_2: "Home_ServiceDetail_1_Content_2",
    content_3: "Home_ServiceDetail_1_Content_3",
    content_4: "Home_ServiceDetail_1_Content_4",
    content_5: "Home_ServiceDetail_1_Content_5",
    ref: "#service_1",
  },
  {
    title: "Home_Service_2",
    img: img_service_2,
    content_title: "Home_ServiceDetail_2_ContentTitle",
    content_subtitle: "Home_ServiceDetail_2_ContentSubtitle",
    content_0: "Home_ServiceDetail_2_Content_0",
    content_1: "Home_ServiceDetail_2_Content_1",
    content_2: "Home_ServiceDetail_2_Content_2",
    content_3: "Home_ServiceDetail_2_Content_3",
    content_4: "Home_ServiceDetail_2_Content_4",
    content_5: "Home_ServiceDetail_2_Content_5",
    ref: "#service_2",
  },
  {
    title: "Home_Service_3",
    content_title: "Home_ServiceDetail_3_ContentTitle",
    content_subtitle: "Home_ServiceDetail_3_ContentSubtitle",
    content_0: "Home_ServiceDetail_3_Content_0",
    content_1: "Home_ServiceDetail_3_Content_1",
    content_2: "Home_ServiceDetail_3_Content_2",
    content_3: "Home_ServiceDetail_3_Content_3",
    content_4: "Home_ServiceDetail_3_Content_4",
    content_5: "Home_ServiceDetail_3_Content_5",
    ref: "#service_3",
  },
];

export const datacomment = [
  {
    content: "ServiceCommentContent_1",
    name: "",
    ponsition: "ServiceCommentPosition_1",
  },
  {
    content: "ServiceCommentContent_2",
    name: "",
    ponsition: "ServiceCommentPosition_2",
    ref: "#service_2",
  },
  {
    content: "ServiceCommentContent_3",
    name: "",
    ponsition: "ServiceCommentPosition_3",
    ref: "#service_3",
  },
  {
    content: "ServiceCommentContent_4",
    name: "",
    ponsition: "ServiceCommentPosition_4",
    ref: "#service_4",
  },
  {
    content: "ServiceCommentContent_5",
    name: "",
    ponsition: "ServiceCommentPosition_5",
    ref: "#service_5",
  },
];

export const imageCarousel = [
  {
    src: home_caousel_1,
    title: "Sunny Pearl",
    subtitle:
      "User experience business-to-business ramen pitch infrastructure seed money analytics channels burn rate",
  },
  {
    src: home_caousel_2,
    title: "Sunny Pearl",
    subtitle:
      "User experience business-to-business ramen pitch infrastructure seed money analytics channels burn rate",
  },
  {
    src: home_caousel_3,
    title: "Sunny Pearl",
    subtitle:
      "User experience business-to-business ramen pitch infrastructure seed money analytics channels burn rate",
  },
];

export const services = [
  {
    img: "mdi:human-male-board-poll",
    title: "Home_Service_1",
    id: "service_1",
    description: "Home_Service_1_All",
    path: path.common.SERVICES,
  },
  {
    img: "fluent-mdl2:report-document",

    title: "Home_Service_2",
    id: "service_2",
    description: "Home_Service_2_All",
    path: path.common.STRATEGY_SERVICE,
  },
  {
    img: "fluent:arrow-growth-20-filled",
    title: "Home_Service_3",
    id: "service_3",
    description: "Home_Service_3_All",
    path: path.common.MANAGEMENT_SERVICE,
  },
];

export const values = [
  {
    icon: Handshake,
    thumbnail: Home_Services_01,
    title: "Home_Value_1",
    description: "Home_ValueDetail_1",
    onclick: false,
    path: null,
  },
  {
    icon: ThumbsUp,
    thumbnail: Home_Services_02,
    title: "Home_Value_2",
    description: "Home_ValueDetail_2",
    onclick: false,
    path: null,
  },
  {
    icon: HandHeart,
    thumbnail: Home_Services_03,
    title: "Home_Value_3",
    description: "Home_ValueDetail_3",
    onclick: true,
    path: path.common.BLOG,
  },
];

export const partners = [
  {
    id: 1,
    name: "AB Group",
    type: ["title_real_estate"],
    logo: imglogoAB,
    banner: imgbanner_ab,
    subtitle: "abtower.vn",
    content: "partner_abgroup_content",
  },
  {
    id: 2,
    name: "Arico",
    type: ["title_other_services"],
    logo: imglogoarico,
    banner: imgbanner_arico,
    subtitle: "arico.com.vn",
    content: "partner_arico_content",
  },
  {
    id: 3,
    name: "Hoshizaki",
    type: ["title_refrigeration_equipment_manufacturing_industry_seafood"],
    logo: imgHoshizaki,
    banner: imgbannerHoshizaki,
    subtitle: "",
    content: "partner_hoshizaki_content",
  },
  {
    id: 4,
    name: "Dimac",
    type: ["title_other_services"],
    logo: imglogodimac,
    banner: imgbanner_dimac,
    subtitle: "dimac-law.com",
    content: "partner_dimac_content",
  },
  {
    id: 5,
    name: "Chin Media",
    type: ["title_logistics"],
    logo: imglogochinmedia,
    banner: imgbanner_chin,
    subtitle: "chinmedia.vn",
    content: "partner_chin_media_content",
  },
  {
    id: 6,
    name: "CT Group",
    type: ["title_real_estate"],
    logo: imglogoctgroup,
    banner: imgbanner_ctgroup,
    subtitle: "ctgroupvietnam.com",
    content: "partner_ctgroup_content",
  },
  {
    id: 7,
    name: "Green pan",
    type: ["title_other_services"],
    logo: imglogogreenpan,
    banner: imgbanner_greenpan,
    subtitle: "greenpan.com.vn",
    content: "partner_green_pan_content",
  },
  {
    id: 8,
    name: "Hiep Phat De La Sol",
    type: ["title_tourism"],
    logo: imglogovilladelsol,
    banner: imgbanner_hiepphat,
    subtitle: "villadelsol.com.vn",
    content: "partner_hiep_phat_content",
  },

  // {
  //   id: 8,
  //   name: "Mitsubishi Estate",
  //   type: ["title_real_estate"],
  //   logo: imglogomitsubishi,
  //   banner: imgbanner_mitsubishi,
  //   subtitle: "mec.co.jp",
  //   content: "partner_mitsubishi_estate_content",
  // },

  {
    id: 9,
    name: "NAM NGHI CORAL PENINSULA PHU QUOC",
    type: ["title_tourism"],
    logo: imglogonamnghi,
    banner: imgbanner_namnghi,
    subtitle: "namnghiresort.com",
    content: "partner_nam_nghi_content",
  },

  {
    id: 10,
    name: "Sai Gon WaterGo",
    type: ["title_tourism"],
    logo: imgwatergo,
    banner: imgbanner_watergo,
    subtitle: "saigonwatergo.com",
    content: "partner_saigon_watergo_content",
  },
  {
    id: 11,
    name: "Sai Gon WaterBus",
    type: ["title_tourism"],
    logo: imgwaterbus,
    banner: imgbanner_waterbus,
    subtitle: "saigonwaterbus.com",
    content: "content_waterbus",
  },
  {
    id: 12,
    name: "SIR Tailor",
    type: ["title_other_services"],
    logo: imgsir,
    banner: imgbanner_sir,
    subtitle: "sirtailor.com",
    content: "content_sirtailor",
  },
  {
    id: 13,
    name: "Song Binh Logistic",
    type: ["title_logistics"],
    logo: imglogosbp,
    banner: imgbanner_songbinh,
    subtitle: "sbp.com.vn",
    content: "content_songbinh",
  },
  {
    id: 14,
    name: "Sunshine Group",
    type: ["title_financial_services"],
    logo: imglogosunshine,
    banner: imgbanner_sunshine,
    subtitle: "sunshinegroup.vn",
    content: "content_sunshine",
  },

  {
    id: 15,
    name: "KN Group",
    type: ["title_financial_services"],
    logo: kng_logo,
    banner: imgbanner_kngroup,
    subtitle: "knparadise.com/",
    content: `content_kngroup`,
  },
  {
    id: 16,
    name: "Hodeco",
    type: ["title_real_estate"],
    logo: imglogohedoco,
    banner: imgbanner_hodeco,
    subtitle: "hodeco.vn",
    content: `content_hodeco`,
  },
  {
    id: 17,
    name: "Hung Thinh Corporation ",
    type: ["title_real_estate"],
    logo: imglogohungthinh,
    banner: imgbanner_hungthinh,
    subtitle: "hungthinhcorp.com.vn",
    content: `content_hungthinh`,
  },
  {
    id: 18,
    name: "IMG Investment Group",
    type: ["title_industrial_park_and_office_real_estate"],
    logo: imgimg,
    banner: imgbanner_img,
    subtitle: "www.img.vn",
    content: `content_img`,
  },

  {
    id: 19,
    name: "JLL",
    type: ["title_asset_management_and_market_research"],
    logo: imgjll,
    banner: imgbanner_jll,
    subtitle: "joneslanglasalle.com.vn",
    content: `content_jll`,
  },

  {
    id: 20,
    name: "Xuan Thao",
    type: ["title_real_estate"],
    logo: imgXuanThao,
    banner: imgbannerXuanThao,
    subtitle: "",
    content: `partner_xuanthao_content`,
  },
  {
    id: 21,
    name: "Phu Cuong",
    type: ["title_food_production"],
    logo: imgPhuCuong,
    banner: imgbannerPhuCuong,
    subtitle: "",
    content: `partner_phucuong_content`,
  },
  {
    id: 22,
    name: "Filmore",
    type: ["title_real_estate"],
    logo: imgFilmore,
    banner: imgbannerFilmore,
    subtitle: "filmore.com.vn",
    content: `partner_filmore_content`,
  },
  {
    id: 23,
    name: "MDS",
    type: ["title_resorts_services"],
    logo: imgMDS,
    // banner: imgbanner_jll,
    subtitle: "",
    content: `partner_mds_content`,
  },
  {
    id: 24,
    name: "OKX",
    type: ["title_technology"],
    logo: imgOKX,
    // banner: imgbanner_jll,
    subtitle: "okx.com",
    content: `partner_okx_content`,
  },
  {
    id: 25,
    name: "Startup Vietnam Foundation",
    type: ["title_startup"],
    logo: imgSVF,
    banner: imgbannerSVF,
    subtitle: "svf.org.vn",
    content: `partner_svf_content`,
  },
  {
    id: 26,
    name: "SOKO",
    type: ["title_seed_fund"],
    logo: imgSoko,
    // banner: imgbanner_jll,
    subtitle: "",
    content: `partner_soko_content`,
  },
  {
    id: 27,
    name: "Legendary Chocolatier",
    type: ["title_fmgc"],
    logo: imgLegendaryChocolate,
    banner: imgbannerLegendaryChocolate,
    subtitle: "legendary.com.vn",
    content: `partner_legendary_chocolatier_content`,
  },
  {
    id: 28,
    name: "I.Value",
    type: ["title_human_resources"],
    logo: imgIValue,
    banner: imgbannerIValue,
    subtitle: "ivalue.com.vn",
    content: `partner_ivalue_content`,
  },
  {
    id: 29,
    name: "QUT",
    type: ["title_education"],
    logo: imgQUT,
    banner: imgbannerQUT,
    subtitle: "www.qut.edu.au",
    content: `partner_qut_content`,
  },
  {
    id: 30,
    name: "UQ",
    type: ["title_education"],
    logo: imgUQ,
    banner: imgbannerUQ,
    subtitle: "",
    content: `partner_uq_content`,
  },
];

export const projects = [
  {
    image:
      "https://www.img.vn/uploads/sanpham/an-cuu-city-giai-doan-2-1727076185-sxyft.jpg",
    location: "Phường An Đông, Thành Phố Huế, Tỉnh Thừa Thiên Huế",
    type_project: "Shophouse An Cựu City - giai đoạn 2",
    size: "Gồm: 168 căn (5 tầng)",
    architecture: "CIAC (italia)",
    id: "1",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize:
      "An Cựu City vinh dự nhận giải ba Quy hoạch Đô Thị Quốc Gia vào tháng 04/2019",
    title: "AN CỬU CITY - GIAI ĐOẠN 2",
    category: "Completed",
    Website: "http://www.ancuucity.com.vn/",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },

  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-cong-nghiep-phuoc-dong-mo-rong-1677214417-lg9xn.jpeg",
    location: "Xã Phước Đông, huyện Cần Đước, tỉnh Long An",
    type_project: "N/A",
    size: "465ha",
    architecture: "N/A",
    investor: "Công ty Cổ phần IMG Phước Đông",
    prize: "N/A",
    title: "Khu Công nghiệp Phước Đông mở rộng",
    category: "InProgress",
    Website: "N/A",
    estimate_time: "10/2026",
    id_video: "",
    top_content: "Khu Công Nghiệp Cầu Cảng Phước Đông mở rộng",
    top_content_li_1:
      "Xây dựng một khu công nghiệp hiện đại dành cho các nhà đầu tư: Hàn Quốc, Nhật Bản, Việt Nam ",
    top_content_li_2: " ",
    top_content_li_3: " ",
    bottom_content_li_1: "",
    bottom_content_li_2: "",
    bottom_content_li_3: "",
    bottom_content_li_4: "",
    id: "2",
    list_img: [
      "https://www.img.vn/uploads/sanpham/khu-cong-nghiep-phuoc-dong-mo-rong-1677214417-lg9xn.jpeg",
      "https://www.img.vn/uploads/noidung/images/nxxxxx.jpeg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://www.img.vn/uploads/noidung/images/nxxxxx.jpeg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image: "https://www.img.vn/uploads/sanpham/artemis-i-1564115840-xwnun.jpg",
    location: "Số 3 Lê Trọng Tấn, Quận Thanh Xuân, Hà Nội",
    type_project: "N/A",
    id: "3",
    size: "27 tầng nổi + 3 tầng hầm.",
    architecture:
      "TW Architects (thiết kế kiến trúc), CPG Corporation Pte Ltd (thiết kế MEP) ",
    investor: "Công ty Cổ phần Đầu tư MHL",
    prize: "N/A",
    title: "Artemis I",
    category: "Completed",
    Website: "http://ttbtimghue.com.vn/",
    estimate_time: "05/2017",
    id_video: "",
    top_content: "Vị trí của tòa nhà Artemis",
    top_content_li_1:
      "Tọa lạc tại vị trí được ví như trái tim của thủ đô Hà Nội, tòa nhà Artemis nằm tại nơi giao nhau giữa quận Thanh Xuân và Đống Đa hội tụ năng lượng, vượng khí tài lộc. Tòa nhà Artemis nằm ở phía Nam trung tâm Hà Nội với 04 mặt tiền đường đắc địa: 02 mặt tiền đường Lê Trọng Tấn, 01 mặt tiền đường Trường Chinh và 01 mặt tiền đường Tôn Thất Tùng. Vùng đất này được các chuyên gia đánh giá là “ốc đảo kinh tế” hiếm có khi sở hữu hoạt động giao thương tương đối sầm uất và nhộn nhịp. ",
    top_content_li_2:
      " Trung tâm được xây dựng tại khu đất dự án An Cựu City trực thuộc Công ty cổ phần đầu tư IMG Huế trên diện tích đất 354 m2, diện tích sử dụng trên 780 m2, với kiến trúc 4 tầng rất hiện đại, tổng số vốn đầu tư hơn 1 triệu USD. Tầng 1 gồm: phòng giám đốc, phòng làm việc, phòng học, phòng ăn, nhà bếp, gara xe; Tầng 2, tầng 3 gồm: 14 phòng, trong đó có 12 phòng ngủ của các em và 02 phòng ngủ cán bộ quản lý; Tầng 4 là phòng đa năng và sân chơi ngoài trời. Phòng học được trang bị máy chiếu, máy vi tính, máy điều hòa…các thiết bị hiện đại để giúp các em có thể thuận lợi trong việc học tập và nâng cao các kỹ năng. Mỗi phòng ngủ gồm 02 em, mỗi em đều có không gian học tập riêng của mình. Trung tâm nằm cạnh bể bơi, sân bóng đá, sân tennis nên các em có thể vui chơi giải tỏa căng thẳng khi học tập và phát triển đầy đủ về thể chất.",
    top_content_li_3: " ",
    bottom_content_li_1: "Cách hồ Hoàn Kiếm: 5km",
    bottom_content_li_2:
      "Trung tâm thể thao: Sân tập golf Cảnh Hồ cách 70m, sân tennis cách 90m, Sân tập golf Mipec cách 200m, tổ hợp sân bóng đá mini...",
    bottom_content_li_3:
      "Các bênh viện lớn từ 500m đến 2km: Bệnh viện Bạch Mai, BV. Việt Pháp, BV. Tai Mũi Họng Trung Ương, viện Y học Hàng Không, Viện Đại học Y Dược....",
    bottom_content_li_4:
      "Cách các trường Đại học từ 1-3km: Đại học Y Hà Nội, Thủy Lợi, Ngân Hàng, ĐH Bách Khoa Hà Nội, Xây Dựng, Kinh Tế Quốc Dân...",

    list_img: [
      "https://www.img.vn/uploads/noidung/images/toa-nha-the-artemis-4.jpg",
      "https://www.img.vn/uploads/noidung/images/toa-nha-artemis.jpg",
      "https://www.img.vn/uploads/noidung/images/anh-to-toa-nha.jpg",
      "https://www.img.vn/uploads/noidung/images/csvc-05-phongngu.jpg",
      "https://www.img.vn/uploads/noidung/images/toa-nha-the-artemis-1667642325-rbwqo.jpg",
    ],
  },

  {
    image:
      "https://www.img.vn/uploads/sanpham/trung-tam-ho-tro-phat-trien-tai-nang-tre-mo-coi-img-hue-1727325431-j0dkh.jpg",
    location: "Khu Đô Thị An Cựu City, Tp. Huế",
    type_project: "N/A",
    size: "Diện tích sử dụng trên 780 m2, với kiến trúc 4 tầng rất hiện đại",
    architecture: "N/A",
    investor: "Công ty Cổ phần IMG Phước Đông",
    prize: "N/A",
    title: "Trung tâm hỗ trợ & Phát triển tài năng trẻ mồ côi IMG",
    category: "Completed",
    Website: "http://ttbtimghue.com.vn/",
    estimate_time: "30/8/2018",
    id_video: "JOWjy_SZM3w",
    top_content:
      "Phương châm hoạt động của Tập đoàn Công ty cổ phần Đầu tư IMG “Tạo dựng giá trị bền vững cho xã hội và các thế hệ tương lai”, từ đó IMG xác nhận chiến lược dài hạn là cùng đồng thời phát triển hoạt động kinh doanh hiệu quả, việc thực hiện trách nhiệm với cộng đồng, nhất là cộng đồng trẻ em chịu nhiều bất hạnh và thiệt thòi cần đặc biệt quan tâm. Đó chính là nguyên nhân IMG thành lập Trung tâm Hỗ trợ và Phát triển tài năng trẻ mồ côi IMG Huế, với quyết tâm góp một phần nhỏ để chữa lành vết đau trong tâm hồn bằng tình yêu thương thực sự nhằm giúp các em trưởng thành, tiến bộ, hoàn thiện về nhân cách và thể chất trở thành công dân tốt cho xã hội trong tương lai.",
    top_content_li_1:
      " Tiền thân của Trung tâm Hỗ trợ và Phát triển tài năng trẻ mồ côi IMG Huế là Cơ sở bảo trợ xã hội chăm sóc trẻ em có hoàn cảnh đặc biệt IMG Huế nhưng do thay đổi giám đốc, trụ sở và tên cơ sở nên được Sở LĐTBXH tỉnh TT-Huế cấp lại giấy chứng nhận đăng ký thành lập số 1587/GCN-SLĐTBXH ngày 14/8/2018 và giấy phép hoạt động số 1753/GP-SLĐTBXH ngày 30/8/2018.",
    top_content_li_2:
      " Trung tâm được xây dựng tại khu đất dự án An Cựu City trực thuộc Công ty cổ phần đầu tư IMG Huế trên diện tích đất 354 m2, diện tích sử dụng trên 780 m2, với kiến trúc 4 tầng rất hiện đại, tổng số vốn đầu tư hơn 1 triệu USD. Tầng 1 gồm: phòng giám đốc, phòng làm việc, phòng học, phòng ăn, nhà bếp, gara xe; Tầng 2, tầng 3 gồm: 14 phòng, trong đó có 12 phòng ngủ của các em và 02 phòng ngủ cán bộ quản lý; Tầng 4 là phòng đa năng và sân chơi ngoài trời. Phòng học được trang bị máy chiếu, máy vi tính, máy điều hòa…các thiết bị hiện đại để giúp các em có thể thuận lợi trong việc học tập và nâng cao các kỹ năng. Mỗi phòng ngủ gồm 02 em, mỗi em đều có không gian học tập riêng của mình. Trung tâm nằm cạnh bể bơi, sân bóng đá, sân tennis nên các em có thể vui chơi giải tỏa căng thẳng khi học tập và phát triển đầy đủ về thể chất.",
    top_content_li_3:
      " Tại trung tâm các em sẽ được đi học ở các trường công lập trên địa bàn thành phố Huế, ngoài giờ học trên lớp Trung tâm sẽ đào tạo các em các kỹ năng nâng cao và kỹ năng sống, tạo điều kiện tốt nhất để các em phát triển năng lực tiềm ẩn của bản thân. Các em sẽ được nuôi dạy, ăn học đến sau đại học và được tạo điều kiện để đi học nước ngoài.",
    bottom_content_li_1: "",
    bottom_content_li_2: "",
    bottom_content_li_3: "",
    bottom_content_li_4: "",
    id: "4",
    list_img: [
      "https://www.img.vn/uploads/noidung/images/41732710-2249332242022867-7355830212564615168-n.jpg",
      "https://www.img.vn/uploads/noidung/images/khai-truong-trung-tam-ho-tro-va-phat-trien-tai-nang-tre-mo-coi-img-hue-hinh-anh71268740814.jpg",
      "https://www.img.vn/uploads/noidung/images/khai-truong-trung-tam-ho-tro-va-phat-trien-tai-nang-tre-mo-coi-img-hue-hinh-anh71268740814.jpg",
      "https://www.img.vn/uploads/noidung/images/csvc-05-phongngu.jpg",
      "https://www.img.vn/uploads/noidung/images/0-02-06-4d1bff087c14b884726879d5e6dc3df53ca6c10d078ebad62f786e0635aeba9e-25dfa8a85c0.jpg",
    ],
  },

  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
    location: "xã Long Hưng, Thị xã Gò Công, tỉnh Tiền Giang",
    type_project: "N/A",
    size: "429ha",
    architecture: "N/A",
    investor: "Công ty Cổ phần IMG Phước Đông",
    prize: "N/A",
    title: "Khu Đô thị Gò Công Central",
    category: "Inprogress",
    Website: "N/A",
    estimate_time: "2025",
    id_video: "",
    top_content: "",
    top_content_li_1: " ",
    top_content_li_2: " ",
    top_content_li_3: " ",
    bottom_content_li_1: "",
    bottom_content_li_2: "",
    bottom_content_li_3: "",
    bottom_content_li_4: "",
    id: "5",
    list_img: [
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
    ],
  },

  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-dan-cu-190ha-phuoc-tuy-1677210433-yqq4q.png",
    title: "KHU DÂN CƯ PHƯỚC TUY",
    category: "InProgress",
    id: "6",
    location: "xã Long Hưng, Thị xã Gò Công, tỉnh Tiền Giang",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image: "https://www.img.vn/uploads/noidung/images/go-cong-central.jpg",
    title: "KHU ĐÔ THỊ GÒ CÔNG CENTRAL",
    category: "InProgress",
    location: "xã Long Hưng, Thị xã Gò Công, tỉnh Tiền Giang",
    id: "7",
    type_project: "N/A",
    size: "29ha",
    architecture: "N/A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",
    Website: "N/A",
    estimate_time: "2025",
    id_video: "",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },

  {
    image:
      "https://www.img.vn/uploads/sanpham/kcn-cau-cang-phuoc-dong-1608704777-cnq9c.png",
    title: "KHU CÔNG NGHIỆP PHƯỚC ĐÔNG MỞ RỘNG",
    category: "Completed",
    location:
      "Ấp 5, đường tỉnh 826B, Xã Phước Đông, Huyện Cần Đước, Tỉnh Long An",
    id: "8",
    type_project: "N/A",
    size: "N/A",
    architecture: "N/A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize:
      "Khu công nghiệp cầu cảng Phước Đông vinh dự được trao giải nhì Quy hoạch Đô Thị Quốc Gia vào ngày 12/12/2021 ",

    Website: "N/A",
    estimate_time: "21/03/2021",
    id_video: "FTkbBcQOwoY",
    top_content: " 1. VỊ TRÍ KCN PHƯỚC ĐÔNG:",
    top_content_li_1:
      "Công nghiệp điện tử, tin học, phương tiện thông tin, viễn thông (bao gồm các công đoạn theo công nghệ sản xuất khép kín của Dự án như sơn, phun phủ, xi mạ, làm sạch bề mặt kim loại bằng hóa chất…); ",
    top_content_li_2:
      "Công nghiệp sản xuất thép xây dựng, thép ống (bao gồm các công đoạn theo công nghệ sản xuất khép kín của Dự án như sơn, xi mạ, làm sạch bề mặt kim loại bằng hóa chất, đánh bóng kim loại…; không đúc, không luyện);",
    top_content_li_3:
      "Công nghiệp sản xuất đồ gỗ, trang trí nội thất; chế biến gỗ, dăm gỗ từ gỗ tự nhiên; vật liệu xây dựng (không sản xuất xi măng, không sản xuất clinke, không sản xuất vôi); sơn dùng trong xây dựng;",
    bottom_content_li_1:
      "Phía Bắc: Giáp Đường tỉnh 826B, khu dân cư hiện hữu dọc theo đường tỉnh 826B và ruộng lúa.",
    bottom_content_li_2: "Phía Nam: Giáp Sông Vàm Cỏ",
    bottom_content_li_3: "Phía Đông: Giáp kênh Nước Mặn",
    bottom_content_li_4:
      "Phía Tây: Giáp ruộng lúa và Khu dân cư – tái định cư hiện hữu.",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-cong-nghiep-cau-cang-phuoc-dong-1675927048-bw3r.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/nha-xuong-img-phuoc-dong-1667371746-31RTZ.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/nha-xuong-img-phuoc-dong-1695356757-d5e9.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-cong-nghiep-cau-cang-phuoc-dong-1667614076-RY17g.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-cong-nghiep-cau-cang-phuoc-dong-1667614076-RY17g.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/trung-tam-ho-tro-phat-trien-tai-nang-tre-mo-coi-img-hue-1727325431-j0dkh.jpg",
    title: "TRUNG TÂM HỖ TRỢ VÀ PHÁT TRIỂN TÀI NĂNG TRẺ MỞ",
    category: "InProgress",
    id: "9",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/an-cuu-city-giai-doan-2-1727076185-sxyft.jpg",
    title: "AN CỬU CITY - GIAI ĐOẠN 2",
    category: "Completed",
    id: "10",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-dan-cu-190ha-phuoc-tuy-1677210433-yqq4q.png",
    title: "KHU DÂN CƯ PHƯỚC TUY",
    category: "InProgress",
    id: "11",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
    title: "KHU ĐÔ THỊ GÒ CÔNG CENTRAL",
    category: "Completed",
    id: "12",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-cong-nghiep-phuoc-dong-mo-rong-1677214417-lg9xn.jpeg",
    title: "KHU CÔNG NGHIỆP PHƯỚC ĐÔNG MỞ RỘNG",
    category: "InProgress",
    id: "13",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/trung-tam-ho-tro-phat-trien-tai-nang-tre-mo-coi-img-hue-1727325431-j0dkh.jpg",
    title: "TRUNG TÂM HỖ TRỢ VÀ PHÁT TRIỂN TÀI NĂNG TRẺ MỞ",
    category: "Completed",
    id: "14",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/an-cuu-city-giai-doan-2-1727076185-sxyft.jpg",
    title: "AN CỬU CITY - GIAI ĐOẠN 2",
    category: "Completed",
    id: "15",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-dan-cu-190ha-phuoc-tuy-1677210433-yqq4q.png",
    title: "KHU DÂN CƯ PHƯỚC TUY",
    category: "InProgress",
    id: "16",
    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",

    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-do-thi-go-cong-central-1700108534-uxzuk.jpg",
    title: "KHU ĐÔ THỊ GÒ CÔNG CENTRAL",
    category: "InProgress",

    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",
    id: "17",
    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/khu-cong-nghiep-phuoc-dong-mo-rong-1677214417-lg9xn.jpeg",
    title: "KHU CÔNG NGHIỆP PHƯỚC ĐÔNG MỞ RỘNG",
    category: "InProgress",

    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",
    id: "18",
    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
  {
    image:
      "https://www.img.vn/uploads/sanpham/trung-tam-ho-tro-phat-trien-tai-nang-tre-mo-coi-img-hue-1727325431-j0dkh.jpg",
    title: "TRUNG TÂM HỖ TRỢ VÀ PHÁT TRIỂN TÀI NĂNG TRẺ MỞ",
    category: "InProgress",

    type_project: "N/A",
    size: "N/A",
    architecture: "N?A",
    investor: "Công ty Cổ phần Đầu tư IMG Huế",
    prize: "N/A",

    Website: "N/A",
    estimate_time: "10/2024",
    id_video: "04uZ36O46Jo",
    top_content:
      "An Cựu City sở hữu vị trí lý tưởng ngay trung tâm thành phố Huế, ngay trục đường Hoàng Quốc Việt và Võ Nguyên Giáp:",
    top_content_li_1:
      "Nằm tại trung tâm Thành phố Huế, trong khu đô thị mới An Vân Dương được quy hoạch đồng bộ hiện đại. ",
    top_content_li_2:
      "Nằm cạnh trung tâm hành chính của Thành phố Huế và trung tâm hành chính của Tỉnh Thừa Thiên Huế trên trục đường Võ Nguyên Giáp, trục đường lớn nhất của Tỉnh có chiều rộng 100m (IMG Huế là đơn vị đầu tiên tham gia thiết kế, thi công và mở ra tuyến đường này). ",
    top_content_li_3:
      "Khu shophouse nằm đối diện đại siêu thị AEON Mall (Nhật Bản) được khai trương vào ngày 21/09/2024, được đánh giá là khu vực đắc địa nhất tại tỉnh Thừa Thiên Huế. ",
    bottom_content_li_1: "Phía Đông: Giáp với đường Võ Nguyên Giáp",
    bottom_content_li_2: "Phía Tây: Giáp với khu Dân cư",
    bottom_content_li_3: "Phía Nam: Giáp với sông An Cựu",
    bottom_content_li_4: "Phía Bắc: Giáp với đường Hoàng Quốc Việt",
    id: "19",
    list_img: [
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792823-Cx1w7.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792825-xaNnG.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792898-0ZW6R.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792881-KQ6L2.jpg",
      "https://imgproduct.vn/uploads/tt_hinh/khu-do-thi-an-cuu-city-1667792942-hmjk7.jpg",
    ],
  },
];
